import { lazyVue } from "@/utils";
export default [{
    path: '/myselfcardInfo',
    name: 'myselfcardInfo',
    title: '我的会员',
    component: lazyVue('my/myselfcardInfo/index'),
    meta: {
        // showBar:1,
        title: '我的会员',
        name: '我的会员'
    }
}]


// WEBPACK FOOTER //
// ./src/router/myselfcardInfo/index.js